import React from 'react';

import ResultPointsTable from '../../components/tables/result-points-table';

export const ResultTablePage: React.FC = () => {
  return <ResultPointsTable />;
};
